import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import Alert from "../../common/alert/Alert";
import {
  Modal,
  Button,
  Row,
  Col,
  FormGroup,
  FormLabel,
  FormControl,
  FormCheck,
  Form,
} from "react-bootstrap";
import { TypeaheadInputSingle } from "react-bootstrap-typeahead";
import {
  ID_PREFIX_RICH_MARK,
  ID_PREFIX_SORTABLE_BOX,
  ID_PREFIX_CONTAINED_VIEW,
  PAGE_TYPES,
  ID_PREFIX_PAGE,
  ID_PREFIX_BOX,
} from "../../../../common/constants";
import i18n from "i18next";
import { isSection, isContainedView, nextAvailName } from "../../../../common/utils";
import "../rich_marks_modal/_richMarksModal.scss";
import IdealStudio from "../../../../core/editor/main";
import { createBox } from "../../../../common/common_tools";
import { colors } from "@mui/material";

/**
 * Modal component to edit marks' configuration
 */
export default class AudioPlayer extends Component {
  /**
   * Constructor
   * @param props
   */
  constructor(props) {
    super(props);

    this.state = {
      playing: false,
      muted: false,
      currentDuration: 0,
    };

    this.audio = new Audio(this.props.file);
    this.audio.loop = true;
    const vol =
      typeof this.props.volume === "number" && Number.isFinite(this.props.volume)
        ? Math.max(0, Math.min(1, this.props.volume))
        : 1;
    this.audio.volume = vol;
    this.playOrPause = this.playOrPause.bind(this);
  }

  componentDidUpdate() {
    if (
      this.interval != null &&
      this.state.currentDuration > 0 &&
      this.props.duration > 0 &&
      this.state.currentDuration >= this.props.duration
    ) {
      this.setState(
        {
          currentDuration: 0,
        },
        () => {
          this.playOrPause(false);
          this.audio.currentTime = 0;
        }
      );
    }
  }

  /**
   * Render React Component
   * @returns {code}
   */
  render() {
    return (
      <div style={{ display: "block", gap: "5rem" }}>
        <div style={{ float: "left" }}>
          <button
            className="editorTitleButton"
            onClick={() => this.playOrPause(!this.state.playing)}
          >
            {this.state.playing ? (
              <i className="material-icons">pause</i>
            ) : (
              <i className="material-icons">play_arrow</i>
            )}
          </button>
        </div>
        <div style={{ float: "left", display: "inline-flex" }}>
          <label>{this.convertDurationToTimeFormat(this.state.currentDuration)}</label>{" "}
          <label style={{ position: "absolute", left: "83%" }}>
            {this.convertDurationToTimeFormat(
              this.props.duration >= 0 ? this.props.duration : 0
            )}{" "}
          </label>
          <div style={{ position: "absolute", bottom: "25%", width: "74%" }}>
            <input
              onChange={(e) => {
                this.setState({ currentDuration: e.target.value });
                this.audio.currentTime = e.target.value % this.audio.duration;
              }}
              value={this.state.currentDuration}
              min={0}
              max={this.props.duration}
              type="range"
              style={{ color: "black", gap: "5rem" }}
            />
          </div>
        </div>
        {/* <button onClick={() => this.setState({muted: !this.state.muted},() => {this.audio.muted = this.state.muted}) }>{ (this.state.muted || this.props.volume == 0) ? "On": "Off"}</button>*/}
      </div>
    );
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.duration != nextProps.duration) {
      this.setState(
        {
          currentDuration: 0,
        },
        () => {
          this.playOrPause(false);
          this.audio.currentTime = 0;
        }
      );
    }

    if (this.props.volume != nextProps.volume) {
      this.audio.volume = nextProps.volume;
    }

    if (this.props.file != nextProps.file || this.props.fileBlob != nextProps.fileBlob) {
      this.setState(
        {
          currentDuration: 0,
        },
        () => {
          this.audio.src = nextProps.file;
          this.audio.currentTime = 0;
          this.playOrPause(false);
        }
      );
    }

    if (this.props.fileBlob != nextProps.fileBlob) {
      this.audio.src = URL.createObjectURL(nextProps.file);
    }

    if (this.props.modalVisible && !nextProps.modalVisible) {
      this.setState(
        {
          currentDuration: 0,
        },
        () => {
          this.audio.src = "";
          this.audio.currentTime = 0;
          this.playOrPause(false);
        }
      );
    }
  }

  convertDurationToTimeFormat(duration) {
    let minutes = Math.floor(duration / 60).toString();
    let seconds = duration % 60 < 10 ? "0" + (duration % 60) : (duration % 60).toString();

    return minutes + ":" + seconds;
  }

  playOrPause(playing) {
    if (this.props.duration > 0) {
      this.setState(
        {
          playing: playing,
        },
        () => {
          if (this.state.playing) {
            this.audio.play();
            this.interval = setInterval(() => {
              this.setState({ currentDuration: ++this.state.currentDuration });
            }, 1000);
          } else {
            this.audio.pause();
            clearInterval(this.interval);
          }
        }
      );
    }
  }
}
